/*
 * Creator Content Strip — pause video playback when off-screen.
 * Videos mark themselves autoplay/muted/loop/playsinline in markup;
 * we only need to save resources when they leave the viewport.
 */

(function () {
  'use strict';

  function initStrip(strip) {
    if (strip.dataset.pcStripBound === '1') return;
    strip.dataset.pcStripBound = '1';

    var videos = strip.querySelectorAll('[data-pc-strip-video]');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) {
        var p = v.play && v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          var p = v.play && v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.25 });

    videos.forEach(function (v) { observer.observe(v); });
  }

  function initAll() {
    document.querySelectorAll('[data-pc-strip]').forEach(initStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('[data-pc-strip]').forEach(initStrip);
  });
})();
